<template>
  <div class="">
    <Table
      stripe
      :columns="columns"
      :data="fieldList"
    ></Table>
  </div>
</template>

<script>
import { fieldType } from '@/assets/globalData'

export default {
  props: {
    id: {
      required: true
    }
  },
  data () {
    return {
      columns: [
        {
          title: '字段名称',
          key: 'name',
          width: 140
        },
        {
          title: '字段类型',
          key: 'type',
          width: 140,
          render: (h, { row }) => {
            return this.getFieldTypeName(row.type)
          }
        },
        {
          title: '是否必填',
          key: 'isRequired',
          width: 100,
          render: (h, { row }) => {
            return row.isRequired ? '是' : '否'
          }
        },
        {
          title: '其他',
          key: 'other',
          render: (h, { row }) => {
            return row.other ? row.other : '-'
          }
        },
        {
          title: ' ',
          key: ' '
        }
      ],
      fieldList: []
    }
  },
  methods: {
    // 根据type获取自定义字段类型名称
    getFieldTypeName (type) {
      for (let t of fieldType) {
        if (t.value === type) {
          return t.name
        }
      }
    }
  },
  created () {
    // this.fieldList = [{
    //   name: 'a',
    //   type: 'b',
    //   isRequired: 'c',
    //   other: 'd'
    // }]
    this.$http.get('/templateExamine/field', {
      params: {
        id: this.id
      }
    }).then(res => {
      if (res.success) {
        this.fieldList = res.data
      } else {
        this.$Message.error(res.message)
      }
    })
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/templeManage/templeMarket/TemplateField.vue